import { useState, useEffect } from 'react';
import { attributeStore } from '../../../store/attributeStore';
import { compareArraysIgnoringFirstElement, deepClone } from '../utils/arrayUtils';

/**
 * Custom hook for managing table rows with caching
 * @param {Array} rowsPreload - Initial rows data
 * @param {string} cacheKey - Cache key for storing data
 * @param {boolean} ignoreCache - Whether to ignore cached data
 * @param {Function} setChanges - Function to set changes state
 * @param {Function} setWasFileUploaded - Function to set file upload state
 * @returns {Object} - Object with rows state and setter
 */
export function useTableRows(rowsPreload, cacheKey, ignoreCache, setChanges, setWasFileUploaded) {
  const [rows, setRows] = useState(() => {
    if (ignoreCache) {
      if (setWasFileUploaded) {
        setWasFileUploaded(true);
      }
      return deepClone(rowsPreload);
    }
    
    const cachedRows = attributeStore[cacheKey];
    if (cachedRows && cachedRows.length !== 0 && 
        !compareArraysIgnoringFirstElement(deepClone(cachedRows), rowsPreload)) {
      setChanges(true);
      return cachedRows;
    } else {
      return rowsPreload;
    }
  });

  useEffect(() => {
    attributeStore[cacheKey] = rows;
  }, [rows, cacheKey]);

  return { rows, setRows };
}
